module.exports = __webpack_public_path__ + "img/plan4.8662b27e.svg";